import React,{ useContext } from 'react'
import { Flex } from 'theme-ui'
import { useState } from 'react'
import ClosePanel from './ClosePanel'
import PanelItemsList from './PanelsList/PanelsList'
import PanelItem from './PanelItem/PanelItem'
import { CanvasContext } from '../hooks/LessonPage'
// import { useCanvasContext } from '@/hooks'

function Panels() {
  const [panelOpen, setPanelOpen] = useState(false)
  const [activeTab, setActiveTab] = useState('')
  const { actions } = useContext(CanvasContext);
  
  // const { canvasType } = useCanvasContext()
  const closePanel = () => {
    setPanelOpen(!panelOpen)
    actions.setTargetRef(null)
  }
  const isPanelOpen = panelOpen
  return (
    <Flex
      sx={{
        position: 'relative',
        background: '#2ab3bd',
        boxShadow: '5px 0 5px -5px rgba(0, 0, 0, 0.5)',
        userSelect: 'none',
      }}
    >
      <PanelItemsList
        setPanelOpen={setPanelOpen}
        panelOpen={isPanelOpen}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
      <PanelItem activeTab={activeTab} panelOpen={isPanelOpen} />
      <ClosePanel panelOpen={isPanelOpen} closePanel={closePanel} />
    </Flex>
  )
}

export default Panels
